import { useSessionProfile } from '@/auth/useSessionProfile';
import { useDistributor } from '@/data/hooks';
import { distributorNotice } from './portal';

/**
 * Tells a distributor user, on every screen of their portal, when their account is suspended, rejected, closed
 * or still in review (and why). Nothing is shown for an active account or while it loads.
 */
export function DistributorStatusBanner() {
  const { profile } = useSessionProfile();
  const query = useDistributor(profile?.distributorId);
  const notice = query.data ? distributorNotice(query.data.status, query.data.statusReason) : undefined;
  if (!notice) return null;

  return (
    <p
      role={notice.tone === 'danger' ? 'alert' : 'status'}
      className={
        notice.tone === 'danger'
          ? 'mb-6 rounded-md border border-danger-soft bg-danger-soft p-3 text-sm font-medium text-danger'
          : 'mb-6 rounded-md border border-warning-soft bg-warning-soft p-3 text-sm text-text-primary'
      }
    >
      {notice.text}
    </p>
  );
}
